import { render, staticRenderFns } from "./PubFormSettingsEditor.vue?vue&type=template&id=3bfdcf62"
import script from "./PubFormSettingsEditor.vue?vue&type=script&lang=js"
export * from "./PubFormSettingsEditor.vue?vue&type=script&lang=js"
import style0 from "./PubFormSettingsEditor.vue?vue&type=style&index=0&id=3bfdcf62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports